import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { RepeatingEventDetail } from '../components/repeating-events/RepeatingEventDetail'
import { SceneContainer } from '../components/scene/SceneContainer'
import { useCombinedCalendar } from '../store/hooks'

function WorkspaceRepeatingEventScreen() {
  const { workspaceId, repeatingEventId } = useParams()

  const { events, repeatingEvents } = useCombinedCalendar()

  const repeatingEvent = repeatingEvents.find(
    (event) => event.id === repeatingEventId,
  )

  const calendarEvents = useMemo(() => {
    return events.filter(
      (event) =>
        event.repeatingEventId === repeatingEventId &&
        event.workspaceId === workspaceId,
    )
  }, [events, workspaceId, repeatingEventId])

  return (
    <SceneContainer
      breadcrumbs={[
        {
          label: 'Manage events',
          to: `/workspace/${workspaceId}/manage-events/`,
        },
        {
          label: repeatingEvent?.name ?? 'Repeating event',
        },
      ]}
    >
      {!!repeatingEvent && !!workspaceId ? (
        <RepeatingEventDetail
          workspaceId={workspaceId}
          repeatingEvent={repeatingEvent}
          calendarEvents={calendarEvents}
        />
      ) : (
        <div>Not found</div>
      )}
    </SceneContainer>
  )
}

export default WorkspaceRepeatingEventScreen
